'use client';

import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

interface TelegramLinkResponse {
  deep_link: string;
  expires_in: number;
}

export function useTelegramLink() {
  return useMutation({
    mutationFn: () =>
      apiFetch<TelegramLinkResponse>('/telegram/link', { method: 'POST' }),
  });
}
